import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

export const clearAdminSession = () => {
  sessionStorage.removeItem("xs_admin_token");
  sessionStorage.removeItem("xs_admin_exp");
  localStorage.removeItem("xs_admin_token");
  localStorage.removeItem("xs_admin_exp");
  window.dispatchEvent(new Event("xs-auth-changed"));
};

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("xs_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearAdminSession();
    } else if (err?.response?.status === 403 && err?.config?.url?.includes("/admin/")) {
      clearAdminSession();
    }
    return Promise.reject(err);
  }
);

export const mediaUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};

export default api;
